import React from 'react';

import { Controller } from 'react-hook-form';

import { DateMultiInput } from './DateMultiInput';

type ControlledProps = Omit<React.ComponentProps<typeof DateMultiInput>, 'onChange' | 'onFocus' | 'onBlur' | 'value'> &
  Omit<React.ComponentProps<typeof Controller>, 'as'>;

export function DateMultiInputCTL({ control, name, ...rest }: ControlledProps) {
  return (
    <Controller
      as={DateMultiInput}
      name={name ?? ''}
      control={control}
      onChange={([value]) => value as string}
      fullWidth
      {...rest}
    />
  );
}
